/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Rule_AskInputs */

const en_pb_rule_ask = /** @type {(inputs: Pb_Rule_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask first`)
};

const id_pb_rule_ask = /** @type {(inputs: Pb_Rule_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya dulu`)
};

/**
* | output |
* | --- |
* | "Ask first" |
*
* @param {Pb_Rule_AskInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_rule_ask = /** @type {((inputs?: Pb_Rule_AskInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Rule_AskInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_rule_ask(inputs)
	return en_pb_rule_ask(inputs)
});